import { useCallback } from 'react'

import { resetAllModifiedDataByKey, useFormField, useGetFormData } from 'cng-common/features/form'
import { useAppDispatch } from 'cng-common/hooks/useAppDispatch'

import { filtersInitialData, MDF_DASHBOARD_FILTERS_FORM } from '../ui/views/mdfDashboard/config'
import { IMdfDashboardFiltersForm } from '../ui/views/mdfDashboard/models'

export const useMdfDashboardFiltersForm = () => {
  const dispatch = useAppDispatch()

  useGetFormData<IMdfDashboardFiltersForm>(MDF_DASHBOARD_FILTERS_FORM)

  const { value: strategicInitiativesFilterValue, handleChange: changeStrategicInitiatives } =
    useFormField<IMdfDashboardFiltersForm['strategicInitiatives']>({
      defaultValue: filtersInitialData.strategicInitiatives,
      formKey: MDF_DASHBOARD_FILTERS_FORM,
      field: 'strategicInitiatives',
    })

  const { value: businessPrioritiesFilterValue, handleChange: changeBusinessPriorities } =
    useFormField<IMdfDashboardFiltersForm['businessPriorities']>({
      defaultValue: filtersInitialData.businessPriorities,
      formKey: MDF_DASHBOARD_FILTERS_FORM,
      field: 'businessPriorities',
    })

  const { value: timeframesFilterValue, handleChange: changeTimeframes } = useFormField<
    IMdfDashboardFiltersForm['timeframes']
  >({
    defaultValue: filtersInitialData.timeframes,
    formKey: MDF_DASHBOARD_FILTERS_FORM,
    field: 'timeframes',
  })

  const resetFormData = useCallback(() => {
    dispatch(resetAllModifiedDataByKey(MDF_DASHBOARD_FILTERS_FORM))
  }, [dispatch])

  return {
    resetFormData,

    strategicInitiativesFilterValue,
    businessPrioritiesFilterValue,
    timeframesFilterValue,

    changeStrategicInitiatives,
    changeBusinessPriorities,
    changeTimeframes,
  }
}
